module.exports = __webpack_public_path__ + "img/hr-electric-furnace.ba408165.png";